import "./Aside.css"
import { NavLink } from "react-router-dom"
import { useAuth, useData,useTheme } from "../../contexts"

export const Aside=()=>{
  const {sideBar, sideBarHandler}= useData();
  const {token} = useAuth();
  const {theme} = useTheme();
  const getActiveStyle=({isActive})=>({
    backgroundColor: isActive?theme==="dark"?"#34343d":"#cecece":""
  })
    return (
      
      <div className={sideBar? "show-backdrop": "hide-backdrop"}>
        <aside className={sideBar? "showSide  flex-col": "sideBar flex-col"}
        >
          <NavLink to="/"
          style={getActiveStyle}
          >
        <div className="aside-tab flex-row"
        onClick={sideBarHandler}
        >
        <i className="fas fa-home icon-md"></i>
            <p className="aside-subhead">Home</p>
        </div>
        </NavLink>
        <NavLink to={token?"/playlist":"/login"}
        style={getActiveStyle}
        >
        <div className="aside-tab flex-row"
        onClick={sideBarHandler}
        >
        <i className="fas fa-play-circle icon-md"></i>
            <p className="aside-subhead">Playlist</p>
        </div>
        </NavLink>
        <NavLink to={token?"/liked":"/login"}
        style={getActiveStyle}
        >
        <div className="aside-tab flex-row"
        onClick={sideBarHandler}
        >
        <i className="fas fa-thumbs-up icon-md"></i>
            <p className="aside-subhead">Liked</p>
        </div>
        </NavLink>
        <NavLink to={token?"/watchlater":"/login"}
        style={getActiveStyle}
        >
        <div className="aside-tab flex-row"
        onClick={sideBarHandler}
        >
        <i className="far fa-clock icon-md"></i>
            <p className="aside-subhead">Watch Later</p>
        </div>
        </NavLink>
        <NavLink to={token?"/history":"/login"}
        style={getActiveStyle}
        >
        <div className="aside-tab flex-row"
        onClick={sideBarHandler}
        >
        <i className="fas fa-history icon-md"></i>
         <p className="aside-subhead">History</p>
        </div>
        </NavLink>
      </aside>
      </div>
      
    )
}